import {
    FC,
    FunctionComponent,
    MouseEventHandler,
    ReactNode,
    SyntheticEvent,
    useCallback,
    useEffect,
    useState,
} from 'react';
import { useKeyDown } from '@shared/react';
import { useModal } from '@features/Modal';

interface Options {
    close: () => void;
    onClose?: () => void;
    outTransitionTime: number;
    VerificationModal?: FunctionComponent;
    shouldVerify?: boolean;
    localStorageKey?: string;
}

interface Returned {
    shown: boolean;
    onBodyClick: MouseEventHandler;
    closeClick: () => void;
}

export function useModalRender(options: Options): Returned {
    const { close, onClose, outTransitionTime, VerificationModal, localStorageKey } = options;

    const [shown, setShown] = useState<any>(null);

    useEffect(() => {
        setTimeout(() => setShown(true), 50);
    }, []);

    const onBodyClick: MouseEventHandler = (event) => {
        event?.stopPropagation();
    };

    const { open } = useModal(VerificationModal!);

    const closeClick = useCallback(
        (_?: SyntheticEvent, shouldClose?: boolean) => {
            const isObjectChanged = localStorage.getItem(localStorageKey || '');
            if (VerificationModal && !shouldClose && isObjectChanged) {
                open({ closeClick, type: 'verification' });
                return;
            }
            setShown(false);
            setTimeout(() => {
                onClose?.();
                close();
            }, outTransitionTime);
        },
        [close, onClose, outTransitionTime],
    );

    useKeyDown({
        onDown: closeClick,
        keyName: 'Escape',
    });

    return {
        shown,
        onBodyClick,
        closeClick,
    };
}
